import React from 'react';
import PropTypes from 'prop-types';

import PictureFilePicker from 'components/PictureFilePicker/PictureFilePicker';
import * as DocumentExport from 'store/entity/Document';
import message from './message';
import styled from 'styled-components';
import { border1, lightGray } from '../../../../utils/style/colors';

const ContentHolder = styled.div`
  border: ${border1};
  border-radius: 0.5rem;
  padding: 0.5rem;
`;

const SectionHeader = styled.h3`
  font-weight: bold;
  font-size: 1.25rem;
  margin-top: 1rem;
`;

const SectionDescription = styled.p`
  padding: 0.5rem 0;
`;

class ProfilePicture extends React.Component {
  render() {
    const {
      provider,
      changeProfilePicture,
      changeBackground,
      onChangeVerticalBackground,
      onChangeHorizontalBackground,
      hasGeneralAccess = false,
    } = this.props;
    const documents = Object.values(provider?.documents || {});
    const backgrounds = documents?.filter(
      (e) =>
        e.type === 'document' &&
        e.document.documentType === DocumentExport.documentType.banner
    );
    const verticalBackgrounds = documents?.filter(
      (item) =>
        item.type === 'document' &&
        item.document.documentType ===
          DocumentExport.documentType.carouselVertical
    );
    const horizontalBackgrounds = documents?.filter(
      (item) =>
        item.type === 'document' &&
        item.document.documentType ===
          DocumentExport.documentType.carouselHorizontal
    );

    this.background =
      backgrounds.length === 0 ? null : backgrounds[0].document.url;
    this.backgroundItem = backgrounds.length === 0 ? null : backgrounds[0];
    const profilePictures = documents?.filter(
      (e) =>
        e.type === 'document' &&
        e.document.documentType === DocumentExport.documentType.profilePicture
    );
    this.profilePicture =
      profilePictures.length === 0
        ? undefined
        : profilePictures[0].document.url;
    this.profilePictureItem =
      profilePictures.length === 0 ? undefined : profilePictures[0];

    this.verticalBackground =
      verticalBackgrounds.length === 0
        ? null
        : verticalBackgrounds[0].document.url;
    this.verticalBackgroundItem =
      verticalBackgrounds.length === 0 ? null : verticalBackgrounds[0];

    this.horizontalBackground =
      horizontalBackgrounds.length === 0
        ? null
        : horizontalBackgrounds[0].document.url;
    this.horizontalBackgroundItem =
      horizontalBackgrounds.length === 0 ? null : horizontalBackgrounds[0];

    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '0.75rem',
          padding: '0.5rem',
        }}
      >
        <ContentHolder className="round">
          <SectionHeader>{message.profilePicture}</SectionHeader>
          <SectionDescription>
            {message.pleaseSelectProfilePicture}
          </SectionDescription>
          <PictureFilePicker
            src={this.profilePicture}
            item={this.profilePictureItem}
            onPictureChange={changeProfilePicture}
            message={message}
            viewStyle={{
              maxWidth: '15rem',
              maxHeight: '15rem',
              boxShadow: `0.25rem 0.25rem 0.25rem ${lightGray}`,
            }}
            aspectRatio={1}
            imageMaxDimension={{ width: 300, height: 300 }}
            outputFormat="image/png"
            getRatio={true}
          />
        </ContentHolder>
        {!hasGeneralAccess && (
          <>
            <ContentHolder className="flex flex-col gap-3">
              <SectionHeader>{message.background}</SectionHeader>
              <SectionDescription>
                {message.pleaseSelectBackgroundPicture}
              </SectionDescription>
              <PictureFilePicker
                className="section"
                src={this.background}
                item={this.backgroundItem}
                imageMaxDimension={{ width: 600, height: 200 }}
                onPictureChange={changeBackground}
                message={message}
                aspectRatio={3}
                getRatio={true}
                viewStyle={{
                  maxWidth: '15rem',
                  maxHeight: '15rem',
                  boxShadow: `0.25rem 0.25rem 0.25rem ${lightGray}`,
                }}
              />
            </ContentHolder>
          </>
        )}
        <ContentHolder className="flex flex-col gap-3">
          <SectionHeader>{message.backgroundVertical}</SectionHeader>
          <SectionDescription>
            {message.pleaseSelectVerticalBackgroundPicture}
          </SectionDescription>
          <PictureFilePicker
            className="section"
            src={this.verticalBackground}
            item={this.verticalBackgroundItem}
            imageMaxDimension={{ width: 600, height: 1000 }}
            onPictureChange={onChangeVerticalBackground}
            message={message}
            aspectRatio={6 / 10}
            getRatio={true}
            viewStyle={{
              maxWidth: '15rem',
              maxHeight: '15rem',
              boxShadow: `0.25rem 0.25rem 0.25rem ${lightGray}`,
            }}
          />
        </ContentHolder>
        <ContentHolder className="flex flex-col gap-3">
          <SectionHeader>{message.backgroundHorizontal}</SectionHeader>
          <SectionDescription>
            {message.pleaseSelectHorizontalBackgroundPicture}
          </SectionDescription>
          <PictureFilePicker
            className="section"
            src={this.horizontalBackground}
            item={this.horizontalBackgroundItem}
            imageMaxDimension={{ width: 1000, height: 600 }}
            onPictureChange={onChangeHorizontalBackground}
            message={message}
            aspectRatio={10 / 6}
            getRatio={true}
            viewStyle={{
              maxWidth: '15rem',
              maxHeight: '15rem',
              boxShadow: `0.25rem 0.25rem 0.25rem ${lightGray}`,
            }}
          />
        </ContentHolder>
      </div>
    );
  }
}

ProfilePicture.propTypes = {
  changeProfilePicture: PropTypes.func.isRequired,
  changeBackground: PropTypes.func.isRequired,
  handleChangeVerticalBackground: PropTypes.func.isRequired,
  handleChangeHorizontalBackground: PropTypes.func.isRequired,
  provider: PropTypes.object.isRequired,
  hasGeneralAccess: PropTypes.bool,
};

export default ProfilePicture;
